<template>
  <div>
    <button aria-label="Save" class="pure-button in-activity-button" tabindex="8">
      <save-icon></save-icon>
    </button>
  </div>
</template>

<script>
import SaveIcon from 'components/icons/SaveIcon.vue';

export default {
  components: {
    SaveIcon
  }
};
</script>
